import { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface MetadataFieldProps {
	label: string
	value: string
	icon: LucideIcon
	href?: string
	changed?: boolean
	className?: string
}

export function MetadataField({
	label,
	value,
	icon: Icon,
	href,
	changed = false,
	className
}: MetadataFieldProps) {
	return (
		<div
			className={cn(
				"flex justify-between items-center",
				changed && "bg-primary/10 dark:bg-primary/20 ring-1 ring-primary/30 dark:ring-primary/50 rounded-md px-1.5 py-0.5",
				className
			)}
			role="group"
		>
			<span className="text-xs font-medium text-muted-foreground flex items-center gap-1 shrink-0">
				<div className="h-3 w-3 flex items-center justify-center">
					<Icon className="h-2 w-2 text-primary" />
				</div>
				{label}:
			</span>
			<div className="min-w-0 flex-1 flex justify-end ml-2">
				{href ? (
					<a
						href={href}
						target="_blank"
						rel="noopener noreferrer"
						className="text-xs font-medium text-primary hover:underline break-all text-right"
						title={value}
					>
						{value}
					</a>
				) : (
					<span className="text-xs font-medium text-foreground truncate block text-right" title={value}>
						{value}
					</span>
				)}
			</div>
		</div>
	)
}
